module.exports = __webpack_public_path__ + "media/images/svg/help/wave-desktop-5de5305ad30417b22db392e40f1b7254.svg";